import { Layout } from "components/layout"
import { Bots3DHtmlHead } from "components/layout/3d-bots-head"
import { AbilitiesSection } from "components/pages/bots-3d/abilities-section"
import { BottomSection } from "components/pages/bots-3d/bottom-section"
// import { FaqSection } from "components/pages/bots-3d/faq-section"
import { HowToGetSection } from "components/pages/bots-3d/how-to-get"
import { RaritySection } from "components/pages/bots-3d/rarity-section"
import { RebornSection } from "components/pages/bots-3d/reborn-section"
import { TopSection } from "components/pages/bots-3d/top-section"
import { WHAT_THE_BOTS_BLOCK_ID, WhatTheBots } from "components/pages/bots-3d/what-the-bots"
import { Box } from "components/shared/box"

export default function Bots3d() {
  return (
    <Box className="flex-1 overflow-hidden">
      <TopSection scrollTo={WHAT_THE_BOTS_BLOCK_ID} />
      <WhatTheBots />
      <AbilitiesSection />
      <RebornSection />
      <RaritySection />
      <HowToGetSection />
      {/* <FaqSection /> */}
      <BottomSection />
    </Box>
  )
}

Bots3d.getLayout = (page: React.ReactElement) => {
  return <Layout htmlHead={<Bots3DHtmlHead />}>{page}</Layout>
}

Bots3d.noWeb3 = true
